__turbopack_context__.v({
  "error-message": "checkbox-module-scss-module__vw7LkW__error-message",
  "footer": "checkbox-module-scss-module__vw7LkW__footer",
  "label": "checkbox-module-scss-module__vw7LkW__label",
  "placeholder": "checkbox-module-scss-module__vw7LkW__placeholder",
  "wide": "checkbox-module-scss-module__vw7LkW__wide",
  "wrapper": "checkbox-module-scss-module__vw7LkW__wrapper",
});
